// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"e8152dd2","453":"ad123d3d"}[chunkId] + ".chunk.js";
};